import { render, staticRenderFns } from "./couponreceive.vue?vue&type=template&id=0fc51b9b&scoped=true&"
import script from "./couponreceive.vue?vue&type=script&lang=js&"
export * from "./couponreceive.vue?vue&type=script&lang=js&"
import style0 from "./couponreceive.vue?vue&type=style&index=0&id=0fc51b9b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc51b9b",
  null
  
)

export default component.exports